var map = {
	"./i18n/assets_base.properties": [
		6502,
		502
	],
	"./i18n/assets_base_de.properties": [
		8209,
		209
	],
	"./i18n/assets_base_es.properties": [
		6809,
		809
	],
	"./i18n/assets_base_fr.properties": [
		3573,
		573
	],
	"./i18n/assets_base_it.properties": [
		4841,
		841
	],
	"./i18n/assets_base_ja.properties": [
		4187,
		187
	],
	"./i18n/assets_base_ko.properties": [
		3300,
		300
	],
	"./i18n/assets_base_pl.properties": [
		5578,
		578
	],
	"./i18n/assets_base_th.properties": [
		4833,
		833
	],
	"./i18n/assets_base_zh-Hans.properties": [
		7149,
		149
	],
	"./i18n/assets_base_zh-Hant.properties": [
		5903,
		903
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4148;
module.exports = webpackAsyncContext;